module.exports = __webpack_public_path__ + "img/avatar.0445544b.svg";